/* eslint-disable func-names */
/* eslint-disable default-param-last */
import { ANONYMOUS_CART } from '../Actions';

export default function (state = {}, action) {
  switch (action.type) {
    case ANONYMOUS_CART:
      return action.payload;
    default:
      return state;
  }
}
